export default function BrandLogo({
  name = "PackFigure",
  tagline = "Figurinhas que expressam você",
  logoUrl = "",
  showTagline = false,
  className = "",
}) {
  const isPackFigure = name.replace(/[.\s]/g, "").toLowerCase() === "packfigure";

  if (logoUrl) {
    return <img className={`brand-logo-image ${className}`.trim()} src={logoUrl} alt={name} />;
  }

  return (
    <span className={`brand-lockup ${className}`.trim()} aria-label={`${name}${showTagline ? ` — ${tagline}` : ""}`}>
      <img className="brand-lockup-icon" src="/packfigure-icon.svg" alt="" aria-hidden="true" />
      <span className="brand-lockup-copy">
        <span className="brand-lockup-name">
          {isPackFigure ? <><b>Pack</b><b>Figure</b></> : <b>{name}</b>}
        </span>
        {showTagline && <small>{tagline}</small>}
      </span>
    </span>
  );
}
